import { FunctionComponent, lazy, Suspense, useEffect,  useRef,  } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo } from '../../../../components/formulario/tableStyled';
import GetMembros from "../services/getMembros";
import { Tabler } from "../../../../components/formulario/tableStyled";
import LoadingGif from "../../../../components/loading";
const Rows = lazy(() => import('./rows'));


interface TableConexaoProps {

}

const TabelaVisitante: FunctionComponent<TableConexaoProps> = () => {


  const devRef = useRef<any>(null);
  const {  nextPagina,  } = GetMembros();

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef]);

  return (<>
        <Tabler>
          <Suspense fallback={<LoadingGif />}>
            <CorpoTable
              ref={
                devRef
              }>
                  <Tabela>
                    <>
                      <TabelaCabeca>
                        <tr>
                          {
                            ["Nome", "Email", "Telefone", "Data"]?.map(
                              el =>
                                <th>{el}</th>
                            )
                          }
                        </tr>
                      </TabelaCabeca>
                      <TabelaCorpo >
                        <Rows />
                      </TabelaCorpo>
                    </>
                  </Tabela>

            </CorpoTable>
          </Suspense>
        </Tabler>
  </>);
}

export default TabelaVisitante;
